var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseImage',{attrs:{"src":_vm.squareImagePlaceholder,"data-src":_vm.imageUrl,"variant-name":_vm.IMAGE_VARIANT_NAMES.PRODUCT_SKU_SLIDER_THUMBNAIL,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }